const API = {
  // New APIs
  USER_LOGIN: '/users/login',
  LEDGER_EMAILS: '/ledger-emails',
  ORGANIZATION_SETTINGS: '/organizations/settings',
  USER_FORGOT_PASSWORD: '/users/forgot-password',
  USER_RESET_PASSWORD: '/users/reset-password',
  USER_SIGNUP: '/users/signup',
  USER_SIGNUP_ORG_CODE_AVAILABILITY: '/users/signup/organization-code/availability',
  USER_SIGNUP_VERIFY_OTP: '/users/signup/verify-otp',
  USER_SIGNUP_RESEND_OTP: '/users/signup/resend-otp',
  USERS: '/users',
  BRANCHES: '/branches',
  INVESTMENTS: '/investments',
  DEPOSITS: '/deposits',
  DEPOSIT_PAYMENTS: '/deposit-payments',
  DEPOSIT_PAYMENTS_UNSETTLED: '/deposit-payments/list/unsettled',
  EXPENSES: '/expenses',
  BILLINGS: '/billings',
  METAL: '/metals',
  BANK_INTEREST: '/bankInterestTypes',
  LOAN_INTEREST: '/loanInterestTypes',
  BANKS: '/banks',
  BANK_ACCOUNT_NAMES: '/bank-account-names',
  AGENTS: '/agents',
  INCENTIVES: '/incentives',
  CUSTOMERS: '/customers',
  METALS: '/metals',
  LOANS: '/loans',
  LOAN_PAYMENTS: '/loan-payments',
  SALES: '/sales',
  SALE_PAYMENTS: '/sale-payments',
  PLEDGES: '/pledges',
  PLEDGE_PAYMENTS: '/pledge-payments',
  REPORTS: '/reports',
  TRANSACTIONS: '/transactions',
  BRANCH_TRANSFERS: '/branch-transfers',


  // Old APIs
  CUSTOMER: '/kgfcustomer/customer',
  LOGIN: '/kgfuser/login',
  DEPOSIT: '/kgfdeposit-expense/deposit',
  SEARCH_DEPOSIT: 'kgfdeposit-expense/searchdeposit',
  DEPOSIT_PAYMENT: 'kgfdeposit-expense/payment',
  DEPOSIT_CLOSE: 'kgfdeposit-expense/close',
  EXPENSE: '/kgfdeposit-expense/expense',
  LOAN: '/kgfloan/loan',
  SEARCH_LOAN: 'kgfloan/searchloan',
  LOAN_PAYMENT: '/kgfloan/payment',
  PLEDGE: '/kgfpledge/pledge',
  SEARCH_PLEDGE: '/kgfpledge/search-pledge',
  CLOSE_PLEDGE: 'kgfpledge/close-pledge',
  PLEDGE_PAYMENT: '/kgfpledge/payment',
  INTEREST_SCHEME: '/kgfloan/interest',
  GET_BANK: '/kgfpledge/bankscheme',
  GET_BRANCH: '/kgfpledge/kgfbranch',
  BANK_SCHEME: '/kgfpledge/bank-scheme',
  CREATE_USER: '/kgfuser/create',
  USER: '/kgfuser/user',
  BANK_ACCOUNT: '/kgfpledge/bank-account',
  GOLD_PRICE: 'kgfloan/price',
  EXPENSE_TRANSACTION: 'kgfdeposit-expense/transaction',
  OUR_REPORT: 'kgfdeposit-expense/overview',
  INVESTMENT: 'kgfdeposit-expense/ownerdeposit',
  UNCLOSED_PLEDGE: 'kgfloan/unclosedPledge',
};

export default API;
